<template>
  <div>
    404
  </div>
</template>


<script>

export default {
  name: 'Index',
  data () {
    return {
      showViewer: false, // 显示查看器
    }
  },
  mounted () {
    // if (!window.sessionStorage.getItem('userInfo')) {
    //   this.$router.push('/login')
    // } else {
    //   this.$router.push('/homepage')
    // }
  },
}
</script>